<nav class="navbar fixed-top">
  <!-- Logo in nav bar -->
  <div class="container-fluid">
    <div class="navbar-claim">
      <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
        <a href="#">{{policy?.product_name}}</a>
        <svg class="icon">
          <use xlink:href="#chevron-right-small"></use>
        </svg>
        <a>Add Benefits</a>
      </div>

      <div class="navbar-claim__nav d-lg-none">
        <div class="navbar-claim__nav-current">Add Benefits</div>
      </div>

      <a href="javascript:;" (click)="backToEditModal()" class="navbar-claim__close">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>
    </div>
  </div>
</nav>
@if (count > 0) {
  <main class="page-main">
    <div class="container layout layout--modal">
      <div class="layout__main">
        <div class="central-header text-center justify-content-center">
          <h3 class="font-normal">What <strong>benefits</strong> would you like to <strong>add</strong>?</h3>
        </div>
        <div class="card card--change">
          <div class="card-nav">
            <nav class="tab-nav tab-nav--central">
              <ul class="list-unstyled" id="type-nav">
                @for (class of getClassesWithBenefits(); track class; let i = $index) {
                  <li [ngClass]="{ 'is-active': i === 0 }">
                    <a href="#tab-section-{{ class?.class_id }}">{{ class?.description_1 }}</a>
                  </li>
                }
              </ul>
            </nav>
            <!-- .tab-nav -->
          </div>
          <div class="card-body">
            <div class="policy-tabs">
              @for (class of getClassesWithBenefits(); track class; let i = $index) {
                <div class="policy-tabs__tab" [ngClass]=" i === 0 ? 'is-active' : ''"  id="tab-section-{{class?.class_id}}">
                  <div class="card--addons">
                    @for (benefit of getBenefits(class?.class_id); track benefit) {
                      <div class="card__addon">
                        <div class="card__header">
                          <div class="card__header-detail">
                            <div class="card__header-title">
                              <!-- <svg class="icon icon--md">
                              <use xlink:href="#add-ons-funeral-cover"></use>
                            </svg> -->
                            <img src="https://assets.everything.insure/icn/vaps/sm-{{benefit?.product_vaps_id}}.svg" class="icon icon--md" onerror="this.onerror=null;this.src='assets/icn/vaps/sm-0.svg'" />
                            <img src="assets/insurer/{{benefit?.insurer_id}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                            <a href="javascript:" (click)="openAddOnModel(benefit)" class="button button--sm button--icon button--primary" data-toggle="modal">
                              <svg class="icon icon--sm">
                                <use xlink:href="#plus"></use></svg>Add
                              </a>
                              <h5>{{benefit?.vaps_name}}</h5>
                            </div>
                            <div class="card__header-text">
                              <p class="readmore" data-widget="ReadMore" data-splitlength="25" [innerHTML]="benefit?.vaps_description"></p>
                            </div>
                            <div class="card__header-wrap">
                              <div class="card__header-wording">
                                <a href="#see-wording-modal" class="button-control">
                                  <svg class="icon icon--sm">
                                    <use xlink:href="#modal"></use></svg><strong>See Wording</strong>
                                  </a>
                                </div>
                                <div class="card__header-btn">
                                  <img src="assets/insurer/{{benefit?.insurer_id}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                                  <a href="javascript:" (click)="openAddOnModel(benefit)" class="button button--sm button--icon button--primary" data-toggle="modal">
                                    <svg class="icon icon--sm">
                                      <use xlink:href="#plus"></use></svg>Add
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="card__addon-items">
                            <div class="addon-item">
                              <div class="addon-item__wrap">
                                <div class="addon-item__title">
                                  <strong>James Lungani</strong>
                                  <div class="addon-item__cost">
                                    <p><strong>R 38</strong> /mo</p>
                                  </div>
                                </div>
                                <div class="addon-item__description">Individual Funeral Cover (R 25 000)</div>
                                <div class="addon-item__tray">
                                  <div class="action-icons">
                                    <a href="#delete-alert-modal" id="remove-funeral-item" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Remove"
                                      ><svg class="icon">
                                      <use xlink:href="#trash-bin"></use></svg
                                      ><strong>Remove</strong></a
                                      >
                                      <a href="javascript:" (click)="openAddOnModel(benefit)" data-toggle="modal" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Edit"
                                        ><svg class="icon">
                                        <use xlink:href="#edit-underline"></use></svg
                                        ><strong>Edit</strong></a
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> -->
                            </div>
                          }
                          @for (benefit of included; track benefit) {
                            @if (benefit?.class_id === class?.class_id) {
                              <div class="card__addon has-items" >
                                <div class="card__header">
                                  <div class="card__header-detail">
                                    <div class="card__header-title">
                                      <!-- <svg class="icon icon--md">
                                      <use xlink:href="#add-ons-funeral-cover"></use>
                                    </svg> -->
                                    <img src="https://assets.everything.insure/icn/vaps/sm-{{benefit?.product_vaps_id}}.svg" class="icon icon--md" onerror="this.onerror=null;this.src='assets/icn/vaps/sm-0.svg'" />
                                    <img src="assets/insurer/{{benefit?.insurer_id}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                                    @if (benefit?.add_flag === 1) {
                                      <a href="javascript:" (click)="openAddOnModel(benefit)" class="button button--sm button--icon button--primary" data-toggle="modal">
                                        <svg class="icon icon--sm">
                                          <use xlink:href="#plus"></use></svg>Add
                                        </a>
                                      }
                                      <h5>{{benefit?.name}}</h5>
                                    </div>
                                    <div class="card__header-text">
                                      <p class="readmore" data-widget="ReadMore" data-splitlength="25" [innerHTML]="benefit?.vaps_description"></p>
                                    </div>
                                    <div class="card__header-wrap">
                                      <div class="card__header-wording">
                                        <a href="#see-wording-modal" class="button-control">
                                          <svg class="icon icon--sm">
                                            <use xlink:href="#modal"></use></svg><strong>See Wording</strong>
                                          </a>
                                        </div>
                                        <div class="card__header-btn">
                                          <img src="assets/insurer/{{benefit?.insurer_id}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                                          <a href="#addons-modal-add-single" class="button button--sm button--icon button--primary" data-toggle="modal">
                                            <svg class="icon icon--sm">
                                              <use xlink:href="#plus"></use></svg>Add
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    @for (item of benefit.items; track item) {
                                      <div class="card__addon-items">
                                        <div class="addon-item">
                                          <div class="addon-item__wrap">
                                            <div class="addon-item__title">
                                              <strong>{{ getDescription(item?.detail,0)}}</strong>
                                              <!-- <div class="addon-item__cost">
                                              <p><strong>R 38</strong> /mo</p>
                                            </div> -->
                                          </div>
                                          <div class="addon-item__description">{{ getDescription(item?.detail,1) }}</div>
                                          <div class="addon-item__tray">
                                            <div class="action-icons">
                                              <!-- <a href="#delete-alert-modal" id="remove-funeral-item" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Remove"
                                              ><svg class="icon">
                                              <use xlink:href="#trash-bin"></use></svg
                                              ><strong>Remove</strong></a
                                              > -->
                                              @if (item?.edit === 1) {
                                                <a href="javascript:" (click)="openAddOnModel(item, true)" data-toggle="modal" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Edit"
                                                  ><svg class="icon">
                                                  <use xlink:href="#edit-underline"></use></svg><strong>Edit</strong></a>
                                              }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                              }
                              @for (addon of addons; track addon) {
                                @if (addon?.class_id === class?.class_id) {
                                  <div class="card__addon has-items" >
                                    <div class="card__header">
                                      <div class="card__header-detail">
                                        <div class="card__header-title">
                                          <!-- <svg class="icon icon--md">
                                          <use xlink:href="#add-ons-funeral-cover"></use>
                                        </svg> -->
                                        <img src="https://assets.everything.insure/icn/vaps/sm-{{addon?.vaps_id}}.svg" class="icon icon--md" onerror="this.onerror=null;this.src='assets/icn/vaps/sm-0.svg'" />
                                        <img src="assets/insurer/{{ addon?.insurer_id ? addon?.insurer_id : 'everything-insure'}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                                        @if (!addon?.items) {
                                          <a href="javascript:" (click)="openAddOnModel(addon)" class="button button--sm button--icon button--primary" data-toggle="modal">
                                            <svg class="icon icon--sm">
                                              <use xlink:href="#plus"></use></svg>Add
                                            </a>
                                          }
                                          <h5>{{addon?.description_1}}</h5>
                                        </div>
                                        <div class="card__header-text">
                                          <p class="readmore" data-widget="ReadMore" data-splitlength="25" [innerHTML]="addon?.items[0]?.vaps_description"></p>
                                        </div>
                                        <div class="card__header-wrap">
                                          <div class="card__header-wording">
                                            <a href="javascript:;" (click)="openWordingModal(addon, class.class_id)" class="button-control">
                                              <svg class="icon icon--sm">
                                                <use xlink:href="#modal"></use></svg><strong>See Wording</strong>
                                              </a>
                                            </div>
                                            @if (addon?.add_flag === 1) {
                                              <div class="card__header-btn">
                                                <img src="assets/insurer/{{ addon?.insurer_id ? addon?.insurer_id : 'everything-insure'}}.svg" class="img-fluid" onerror="this.onerror=null;this.src='assets/insurer/0.svg'" />
                                                <a href="#addons-modal-add-single" class="button button--sm button--icon button--primary" data-toggle="modal">
                                                  <svg class="icon icon--sm">
                                                    <use xlink:href="#plus"></use></svg>Add
                                                  </a>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                        @for (item of addon?.items; track item) {
                                          <div class="card__addon-items">
                                            <div class="addon-item">
                                              <div class="addon-item__wrap">
                                                <div class="addon-item__title">
                                                  <strong>{{ getDescription(item?.detail,0) }}</strong>
                                                  <div class="addon-item__cost">
                                                    <p>
                                                      <strong>{{accounting?.formatMoney(item?.premium)}}</strong>/{{policy?.frequency_short}}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="addon-item__description">{{ getDescription(item?.detail,1) }}</div>
                                                <div class="addon-item__tray">
                                                  <div class="action-icons">
                                                    @if (item?.remove === 1) {
                                                      <a href="javascript:;" (click)="setSelectedVap(item)"id="remove-funeral-item" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Remove"
                                                        ><svg class="icon">
                                                        <use xlink:href="#trash-bin"></use></svg><strong>Remove</strong></a>
                                                      }
                                                      @if (item?.edit === 1) {
                                                        <a href="javascript:" (click)="openAddOnModel(item,true)" data-toggle="modal" class="icon-hover icon-hover--flush" data-tooltip="tooltip" data-placement="top" title="Edit"
                                                          ><svg class="icon">
                                                          <use xlink:href="#edit-underline"></use></svg><strong>Edit</strong></a>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /layout -->
                    </main>
                  }
                  @if (count > 0) {
                    <app-disclaimer ></app-disclaimer>
                  }
                  @if (count > 0) {
                    <footer  class="question-tray">
                      <div class="container">
                        <div class="question-tray__alt-controls">
                          <div class="question-tray__alt-summary">
                            <div class="question-tray__alt-summary-address"> {{product?.product_name}}</div>
                            <div class="question-tray__alt-summary-price">
                              <p><strong id="total-amount-example"><em>{{accounting?.formatMoney(product?.price)}}</em></strong> /{{policy?.frequency_short}}</p>
                            </div>
                          </div>
                          <div class="question-tray__alt-btns">
                            <a id="continue-btn" href="javascript:" (click)="backToEditModal()" class="button button--lg button--primary">Done</a>
                          </div>
                        </div>
                      </div>
                    </footer>
                  }
                  <app-addon-modal #addonModalComponent (benefitAdded)="benefitAdded($event)"></app-addon-modal>
                  <div class="modal fade modal--mini " id="no-benefits-modal" tabindex="-1" aria-labelledby="discard-changes-modal" aria-modal="true" role="dialog">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content modal-mini">
                        <div class="modal-mini__heading">
                          <div class="container-fluid">
                            <h4>Oops!</h4>

                          </div>
                        </div>

                        <div class="modal-mini__content">
                          <div class="container-fluid">
                            <div class="rte">
                              <p>
                                There are no more benefits to add to this policy.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="modal-mini__button">
                          <div class="container-fluid">
                            <!-- this should undo any any changes -->
                            <a href="javascript:;" data-dismiss="modal" (click)="backToEditModal()" class="button button--primary" id="demo-discard-changes-trigger">OK</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal fade modal--alert" id="see-wording-modal" tabindex="-1" role="dialog" aria-labelledby="prorata-modal"
                    aria-modal="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content modal-alert modal-alert--sm">

                        <div class="modal-alert__heading">
                          <div class="container">
                            <div class="modal-alert__avatar">
                              <img [src]="'assets/' + sessionDetails?.category_id + '/avatar/happy.png'" class="img-fluid" alt="" onerror="this.onerror=null;this.src='assets/avatar/cebisa-happy.png'">
                            </div>
                            <button class="modal-alert__close" data-dismiss="modal">
                              <svg class="icon">
                                <use xlink:href="#close-circle-small"></use>
                              </svg>
                            </button>
                          </div>
                        </div>

                        <div class="modal-alert__content">
                          <div class="container">
                            <h4 class="vap-name">{{benefit?.heading}}</h4>
                            <div class="rte">
                              <div class="text-left vap-wording" [innerHTML]="benefit?.content | safeHtml">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="modal-alert__button">
                          <div class="container">
                            <button class="button button--lg button--primary" data-dismiss="modal">Okay, got it</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (benefit?.detail) {
                    <div class="modal fade modal--alert" id="delete-alert-modal" tabindex="-1" role="dialog" aria-labelledby="delete-alert-modal" aria-modal="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content modal-alert">
                          <div class="modal-alert__heading">
                            <div class="container">
                              <div class="modal-alert__avatar">
                                <img [src]="'assets/' + sessionDetails.category_id + '/avatar/angry.png'" class="img-fluid" alt="" onerror="this.onerror=null;this.src='assets/avatar/cebisa-angry.png'">
                              </div>
                              <button class="modal-alert__close" data-dismiss="modal">
                                <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
                              </button>
                            </div>
                          </div>
                          <div class="modal-alert__content">
                            <div class="container">
                              <div class="rte">
                                <h4 class="header"><b>Are you sure?</b></h4>
                                <p class="body">You are about to remove <b>{{getDescription(benefit?.detail,1)}}</b> cover for <b>{{ getDescription(benefit?.detail,0)}}</b>.</p>
                              </div>
                              <div class="modal-alert__content-btn">
                                <button class="button button--lg button--primary remove-confirm order-last" (click)="removeVap();" data-dismiss="modal">Yes, please remove it</button>
                                <button class="button button--lg button--secondary remove-dismiss" data-dismiss="modal">No, please keep it</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }